<div class="select-dropdown">
  <miq-checkbox-multigroup
    [groups]="userGroupOptions()"
    #multiGroupCheckbox
    [selectedgroups]="userListedGroups()"
    [formControl]="groupControl"
  ></miq-checkbox-multigroup>
</div>
